<template lang="pug">
  model-form(
        :editable="false"
        switchEdit
        ref="form"
        reset-text="limpiar"
        submit-text="Editar"
        title="Editar producto"
        :fields="formFieldsComputed"
        v-model="formData"
        
        @submit="submit"
        )
    template( slot="header-actions" )
      v-btn( color="primary" @click="submitUPCCode" ) código upc
          v-icon refresh
      v-btn( color="info" @click="fetchPngUpcCode") código Upc
          v-icon cloud_download
      v-btn( color="primary" @click="submitInternalCode" ) código interno
          v-icon refresh
      
    //- template( slot="footer-actions" )
    //-     v-btn.ml-2( color="info" block @click="submit_goOut") Editar y salir
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next'
import FieldsCreate from '../../create/general/fields'
/* models */
import ProductModel from '@/models/Warehouse/WhProduct'
import ItemModel from '@/models/Warehouse/WhItem'
/* vuex */
import {mapActions} from 'vuex'
/* services */
import Translator from '@/services/translator'
import ProductService from '@/services/api/product'

import SubfamilyService from "@/services/api/subfamily/SubfamilyService"
export default {
  name: 'creat-product-general-information',
  props: {
    dataProduct:{
      type: Object,
      required: true,
    },
    updateComponent:{
      type: Boolean,
      default: false,
    },
  },
  data: function(){
    return {
     
      formData: {},
      formFields: FieldsCreate(),
      allowContinue: false,
      product: {},
      loadedProduct:false,
      subfamilyItems : [],
      upcCodes:[],

    }
  },
  computed: {
    formFieldsComputed(){
      return FieldsCreate(this.upcCodes,this.subfamilyItems,this.triggerSubFamily)
    }
  },
  methods: {
    // -- UI Modification
    // -- UPC methods
    /*
     */
    submitUPCCode() {
        this.$refs.form.setWait(true).then(this.fetchUPCCode)
    },
    fetchUPCCode() {
            ProductModel.find('suggest_upc_code')
                .then(this.setUPCCode)
                .then(this.successUPCCode)
                .catch(this.error)
                .then(this.$refs.form.setWait)
        },
    /**
     *
     */
    setUPCCode(data) {
        this.setUPCCodeItems(data)
    },

    /**
     *
     */
    setUPCCodeItems(data) {
        //this.formFields[0].props.items.push(data.suggested_code)
        this.upcCodes.push(data.suggested_code)
    },

    successUPCCode() {
            this.setSnackbar({
                type: 'info',
                title: 'Código UPC',
                message: 'Se agrego el código UPC sugerido.',
                timeout: 3000,
            })
    },
    // -- End UPC methods
    // -- Internal code 
    submitInternalCode() {
      this.$refs.form.setWait(true).then(this.fetchInternalCode)
    },
    fetchInternalCode() {
      ProductModel.params(this.formData.suggest_internal_code_params)
          .find('suggest_internal_code')
          .then(this.setInternalCode)
          .then(this.successInternalCode)
          .catch(this.error)
          .then(this.$refs.form.setWait)
    },
    setInternalCode(data) {
      this.formData['internal_code'] = data.suggested_code
    },
    successInternalCode() {
            this.setSnackbar({
                type: 'info',
                title: 'Código interno',
                message: 'Se agrego el código interno sugerido.',
                timeout: 3000,
            })
        },
    // -- End Internal code
    // -- Create product
    submit() {
      this.setAllowContinue(true)
      this.$refs.form.setWait(true).then(this.updateProduct)
    },
    // -- End Create product
    // -- Create and Update with empty structure.
    submit_goOut() {
      this.$refs.form.setWait(true).then(this.updateProduct(this.formData))
    },
    /*
     */
    updateProduct(data){
      console.log(data,'data for update')
      let model = new ItemModel({id:data.id})
      model.sync(this.formatData(data))
      .then(r=>this.successUpdate(r))
      //.then(this.redirectTo(data))
      .catch(this.error)
      .then(this.$refs.form.setWait)
    },
    /*
     */
    formatData(data){
      let branch  = [...data.branch_offices]
      let format = branch.map(b=>{
        let priceOffice =data.sale_prices.find(sp=>sp.branch_office_id === b.g_branch_office_id)
        b.sale_price = priceOffice.sale_price
        return b
        // console.log(data.sale_prices,'sale_prices')
      })
      data.branch_office_data = format
      data.uom_quantity = data.wh_item.uom_quantity
      data.is_inventoriable = data.wh_item.is_inventoriable
      data.have_decimal_quantity =data.wh_item.have_decimal_quantity
      data.wh_unit_of_measurement_id = data.wh_item.wh_unit_of_measurement_id
      data.uom_quantity = data.wh_item.uom_quantity
      data.tags = data.tags.map(t=>(typeof t ==='object') ? t.id : t)
      return data
    },
    // -- End create and Update with empty structure.
    /*
     */
    successUpdate(){
      this.setSnackbar({
          type: 'success',
          title: 'Éxito',
          message: 'Información Producto editada exitosamente',
          timeout: 3000,
      })
      this.$refs.form.edit=false
      this.$emit('productEdited')
    },
    error(error) {
      console.log(error,'error')
            this.setSnackbar({
                type: 'error',
                title: 'Error',
                message: Translator(ItemModel, error.response.data),
                timeout: 15000,
            })
        },
    reset() {
            this.formData = new ItemModel()
            this.formFields[0].props.items = []
        },
    redirectList(){
      this.$router.push('/products')
    },
    /*
     */
    setAllowContinue(val){
      this.allowContinue = val
    },
    /*
     */
    redirectTo(data){
      if(this.allowContinue){
        // when event is emitted in the father component changes tab
        this.$emit('generalInfo',data) 
      }
      else{
        this.redirectList()
      }
    },
    /*
     */
    // async fillFields(){
    //   let resp = await ProductService.fetchById(this.$route.params.id)
    //   this.setFormData(resp)
      
    // },
    setFormData: async function(model) {
      let response = await this.fetchSubFamily(model.wh_subfamily.wh_family_id)
      if(response === 'setSubfamily'){
        this.formData = model
        this.upcCodes = model.upc_codes
        this.formData.wh_family_id = model.wh_subfamily.wh_family_id
        this.formData.wh_subfamily_id = model.wh_subfamily_id
        this.formData.tags = model.wh_tags

      }
    },
    /*
     */
    triggerSubFamily(ctx){
      
      SubfamilyService.fetchAllSubfamilyByFamilyId(ctx.value.wh_family_id).then(response=>{
          if(response.length >0 ){
            this.subfamilyItems = response
            if(this.$refs.form.edit === true){ 
              this.formData.wh_subfamily_id = null
            }
          }
          else{
            this.formData.wh_subfamily_id = null
            this.setSnackbar({
                type: 'warning',
                title: 'Sin Subfamilias',
                message: 'La Familia seleccionada no posee subfamilias.',
                timeout: 3000,
            })
          }
      })
        
    },
    /*
     */
    fetchSubFamily(idFamily){
      return new Promise((resolve,reject)=>{
        //
        SubfamilyService.fetchAllSubfamilyByFamilyId(idFamily).then(response=>{
            if(response.length >0 ){
              this.subfamilyItems = response
              resolve('setSubfamily')
              
            }
        })
      })
    },
    /*
     */
    fetchPngUpcCode(){
      let arrCode = this.formData.upc_codes
      let nameProduct = this.formData.name
      if(arrCode && arrCode.length>0){
        arrCode.forEach(e=>{
          ProductService.upcImageGenerator(e,nameProduct)
        })
      }
      else{
        this.setSnackbar({
                type: 'error',
                title: 'Error',
                message: "Sin código UPC Asignado",
                timeout: 15000,
            })
      }
    },
    
    // -- Data handling and transformations
    // -- Validations and Error handling
    // -- Other functions
    // -- Vuex mappings
    ...mapActions('SnackbarModalModule', {
      setSnackbar: 'setSnackbar',
    }),
  },
  watch: {
    dataProduct(val){ 
      if(val && this.loadedProduct===false){
        this.setFormData(this.dataProduct)
        this.loadedProduct = true
      }
    },
    updateComponent(val){
      if(val){
        this.setFormData(this.dataProduct)
        this.loadedProduct = false
      }
    }
  },
  components: {
    'model-form': ModelForm,
  },
  // mixins: [],
  // filters: {},
  // -- Lifecycle Methods

  mounted() {
    this.reset()
    //this.setFormData(this.dataProduct)
  },
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
  
</style>